import { useState, useEffect } from "react"

const usePrizeEvent = (prizeData) => {
    const [prizeList, setPrizeList] = useState([])

    // 백엔드 데이터가 왔을 때, 해당 값으로 State 초기화
    useEffect(() => {
        if (prizeData) {
            const tmpList = []
            prizeData.forEach(elem => {
                tmpList.push(elem)
            })
            setPrizeList(tmpList)
        }
    }, [prizeData])

    // ===== 프라이즈 관련 이벤트 =====

    const setPrize = (e, type, index) => {
        const tmpList = [...prizeList]
        const tmpElem = [...tmpList[index]]
        const value = e.target.value

        tmpElem[type] = value
        tmpList[index] = tmpElem
        setPrizeList(tmpList)
    }

    const createPrizeEvent = () => {
        const tmpList = [...prizeList]

        tmpList.push([null, null])
        setPrizeList(tmpList)
    }

    const deletePrizeEvent = (index) => {
        const tmpList = [...prizeList]

        tmpList.splice(index, 1)
        setPrizeList(tmpList)
    }

    const upperPrizeEvent = (index) => {
        const tmpList = [...prizeList]

        if (index > 0) {
            let tmp = tmpList[index - 1]
            tmpList[index - 1] = tmpList[index]
            tmpList[index] = tmp
        }
        setPrizeList(tmpList)
    }

    const downPrizeEvent = (index) => {
        const tmpList = [...prizeList]

        if (index < tmpList.length - 1) {
            let tmp = tmpList[index + 1]
            tmpList[index + 1] = tmpList[index]
            tmpList[index] = tmp
        }
        setPrizeList(tmpList)
    }

    return [
        prizeList,
        setPrize, createPrizeEvent, deletePrizeEvent, upperPrizeEvent, downPrizeEvent
    ]
}

export default usePrizeEvent